import { render, staticRenderFns } from "./BeCaptcha.vue?vue&type=template&id=5f017e4a&scoped=true"
import script from "./BeCaptcha.vue?vue&type=script&lang=js"
export * from "./BeCaptcha.vue?vue&type=script&lang=js"
import style0 from "./BeCaptcha.vue?vue&type=style&index=0&id=5f017e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f017e4a",
  null
  
)

export default component.exports